import { StaticImage } from "gatsby-plugin-image"

import { Icon, UserGeneratedHtml } from "@trueskin-web/components"
import { shineIcon } from "@trueskin-web/theme/icons/shineIcon"

const ProductCallout = ({
  title,
  description,
  textColor,
  primaryColor,
  secondaryColor,
}) => {
  return (
    <div
      sx={{
        p: 4,
        fontSize: 1,
        bg: secondaryColor,
        borderRadius: "8px",
        variant: "vwo.components.productCallout.container",
      }}
    >
      <div
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div
          sx={{
            py: 1,
            px: 2,
            display: "inline-flex",
            color: textColor,
            fontWeight: "bold",
            bg: primaryColor,
            borderRadius: "8px",
            whiteSpace: "nowrap",
            variant: "vwo.components.productCallout.badge",
          }}
        >
          <Icon icon={shineIcon} size="sm" />
          {title}
        </div>
        <div
          sx={{
            position: "relative",
            whiteSpace: "nowrap",
            "& > *": {
              position: "relative",
              border: "2px solid",
              borderColor: secondaryColor,
              borderRadius: "50%",
            },
          }}
        >
          <StaticImage
            src="../../../../images/plan-selection/Doctor-03-min.webp"
            alt=""
            width={40}
            sx={{
              zIndex: 3,
              left: 6,
            }}
          />
          <StaticImage
            src="../../../../images/plan-selection/Doctor-02-min.webp"
            alt=""
            width={40}
            sx={{
              zIndex: 2,
              left: 4,
            }}
          />
          <StaticImage
            src="../../../../images/plan-selection/Doctor-01-min.webp"
            alt=""
            width={40}
          />
        </div>
      </div>
      <UserGeneratedHtml html={description} sx={{ mt: 2 }} />
    </div>
  )
}

export default ProductCallout
